var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-radio-group",
        {
          staticClass: "wrapper-radio-group",
          model: {
            value: _vm.presentationSetup,
            callback: function($$v) {
              _vm.presentationSetup = $$v
            },
            expression: "presentationSetup"
          }
        },
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12", sm: "4" } }, [
                _c(
                  "div",
                  {
                    staticClass: "cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.presentationSetup = 1
                      }
                    }
                  },
                  [
                    _c("h4", { staticClass: "text-center mb-3" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("roomWizard.presentation.standalone")) +
                          " "
                      )
                    ]),
                    _c(
                      "va-card",
                      {
                        staticClass:
                          "pa-2 d-flex flex-column align-center mb-3 card-setup",
                        class: [_vm.presentationSetup === 1 ? "selected" : ""]
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "radiobtn-container d-flex justify-end"
                          },
                          [
                            _c("v-radio", {
                              staticClass: "radio-btn",
                              attrs: { value: 1 }
                            })
                          ],
                          1
                        ),
                        _c("presentation-standalone")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        _vm.isMainTenant
                          ? "roomWizard.presentation.standaloneDescription"
                          : "roomWizard.presentation.standaloneDescriptionTenant"
                      )
                    ) +
                    " "
                )
              ]),
              _c(
                "v-col",
                { staticClass: "te", attrs: { cols: "12", sm: "4" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.presentationSetup = 2
                        }
                      }
                    },
                    [
                      _c("h4", { staticClass: "text-center mb-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("roomWizard.presentation.byomDongle")
                            ) +
                            " "
                        )
                      ]),
                      _c(
                        "va-card",
                        {
                          staticClass:
                            "pa-2 d-flex flex-column align-center mb-3 card-setup",
                          class: [_vm.presentationSetup === 2 ? "selected" : ""]
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "radiobtn-container d-flex justify-end"
                            },
                            [
                              _c("v-radio", {
                                staticClass: "radio-btn",
                                attrs: { value: 2 }
                              })
                            ],
                            1
                          ),
                          _c("presentation-byom-dongle")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          _vm.isMainTenant
                            ? "roomWizard.presentation.byomDongleDescription"
                            : "roomWizard.presentation.byomDongleDescriptionTenant"
                        )
                      ) +
                      " "
                  )
                ]
              ),
              _c("v-col", { attrs: { cols: "12", sm: "4" } }, [
                _c(
                  "div",
                  {
                    staticClass: "cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.presentationSetup = 3
                      }
                    }
                  },
                  [
                    _c("h4", { staticClass: "text-center mb-3" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("roomWizard.presentation.byomNoDongle")
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "va-card",
                      {
                        staticClass:
                          "pa-2 d-flex flex-column align-center mb-3 card-setup",
                        class: [_vm.presentationSetup === 3 ? "selected" : ""]
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "radiobtn-container d-flex justify-end"
                          },
                          [
                            _c("v-radio", {
                              staticClass: "radio-btn",
                              attrs: { value: 3 }
                            })
                          ],
                          1
                        ),
                        _c("presentation-byom-no-dongle")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        _vm.isMainTenant
                          ? "roomWizard.presentation.byomNoDongleDescription"
                          : "roomWizard.presentation.byomNoDongleDescriptionTenant"
                      )
                    ) +
                    " "
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }